import { useCallback, useEffect, useState } from "react";
import { getEnhancement } from "@/lib/enhanceApi";

/** One enhanced vocal; polls every 2.5 s while it is being processed. */
export default function useEnhancement(id) {
  const [item, setItem] = useState(null);
  const [error, setError] = useState(null);
  const refresh = useCallback(async () => {
    try { setItem(await getEnhancement(id)); setError(null); } catch (e) { setError(e); }
  }, [id]);
  useEffect(() => { refresh(); }, [refresh]);
  const running = item?.status === "running";
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(refresh, 2500);
    return () => clearInterval(t);
  }, [running, refresh]);
  return { item, setItem, error, refresh };
}
